<div class="dialog-container">
    <h2 class="dialog-title">Enviar factura electrónica por correo</h2>

    <p class="dialog-subtitle">
        Utiliza este formulario para enviar la factura electrónica a los destinatarios correspondientes.
    </p>

    <!-- Correo destinatario -->
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Correo destinatario</mat-label>
        <input matInput [formControl]="formGrupo.get('mails')" placeholder="correo_1@gmail.com, correo_2@gmail.com" />
        <mat-error *ngIf="formGrupo.get('mails').hasError('required')">Este campo es obligatorio.</mat-error>
        <mat-error *ngIf="formGrupo.get('mails').hasError('emailInvalid')">Formato de correo(s) inválido(s).</mat-error>
    </mat-form-field>
    <small class="helper-text">* Si deseas enviar la factura a varios destinatarios, separa los correos con una coma
        ",".</small>

    <!-- CC (opcional) -->
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>CC (Con Copia)</mat-label>
        <input matInput [formControl]="formGrupo.get('cc')" placeholder="correo_1@gmail.com, correo_2@gmail.com" />
        <mat-error *ngIf="formGrupo.get('cc').hasError('emailInvalid')">Formato de correo(s) inválido(s).</mat-error>
    </mat-form-field>
    <small class="helper-text">Opcional: Añade destinatarios en copia.</small>

    <!-- Asunto -->
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Asunto</mat-label>
        <input matInput [formControl]="formGrupo.get('asunto')" placeholder="Asunto" />
        <mat-error *ngIf="formGrupo.get('asunto').hasError('required')">Este campo es obligatorio.</mat-error>
    </mat-form-field>

    <!-- Mensaje -->
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Mensaje</mat-label>
        <textarea matInput rows="4" [formControl]="formGrupo.get('mensaje')" placeholder="Mensaje"></textarea>
        <mat-error *ngIf="formGrupo.get('mensaje').hasError('required')">Este campo es obligatorio.</mat-error>
    </mat-form-field>

    <!-- Botones -->
    <div class="dialog-actions">
        <button mat-button (click)="close()">Cancelar</button>
        <button mat-raised-button color="primary" [disabled]="formGrupo.invalid" (click)="save()">
            Enviar factura
        </button>
    </div>
</div>